// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.patient-name-container {
    display: flex;
    flex-direction: column;
    margin-bottom: 1.5rem;
    gap: 0.4rem;
  }
  
  .patient-name-container label {
    font-weight: 600;
    color: var(--clr-grey-1); 
    font-size: 0.95rem;
  }
  
  .patient-name-box-1 {
    background-color: var(--clr-grey-10);
    border: 1px solid var(--clr-grey-7);
    border-radius: var(--radius);
    padding: 12px 14px;
    font-size: 1rem;
    color: var(--clr-grey-1);
    box-shadow: var(--light-shadow);
  }
  
  /* Responsive spacing */
  @media (max-width: 768px) {
    .patient-name-box {
      font-size: 0.95rem;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/NewPatientScheduling/styles/PatientNameDisplay.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,oCAAoC;IACpC,mCAAmC;IACnC,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,wBAAwB;IACxB,+BAA+B;EACjC;;EAEA,uBAAuB;EACvB;IACE;MACE,kBAAkB;IACpB;EACF","sourcesContent":[".patient-name-container {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 1.5rem;\n    gap: 0.4rem;\n  }\n  \n  .patient-name-container label {\n    font-weight: 600;\n    color: var(--clr-grey-1); \n    font-size: 0.95rem;\n  }\n  \n  .patient-name-box-1 {\n    background-color: var(--clr-grey-10);\n    border: 1px solid var(--clr-grey-7);\n    border-radius: var(--radius);\n    padding: 12px 14px;\n    font-size: 1rem;\n    color: var(--clr-grey-1);\n    box-shadow: var(--light-shadow);\n  }\n  \n  /* Responsive spacing */\n  @media (max-width: 768px) {\n    .patient-name-box {\n      font-size: 0.95rem;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
